<template>
  <b-form-checkbox
    v-model="inputData"
    :name="name"
    class="dynamic-check"
    :disabled="disabled"
  >
    {{ label }}
  </b-form-checkbox>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    type: String,
    label: String,
    mandatory: Boolean,
    placeholder: String,
    id: String,
    vmodel: Boolean,
    name: String,
    disabled: Boolean,
  },
  watch: {
    vmodel(newValue) {
      this.inputData = newValue;
      console.log("this.inputData", this.inputData);
    },
    inputData(newValue) {
      this.$emit("select-value", newValue);
    },
  },
  data() {
    return {
      inputData: false,
    };
  },
};
</script>
<style>
.dynamic-check .custom-control-label {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #344054;
  line-height: 24px;
  cursor: pointer;
}
.dynamic-check .custom-control-label::before {
  border-radius: 0.1rem;
  border: 1px solid #20639b;
}
.dynamic-check .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: var(--mainblue);
  background-color: var(--mainblue);
  border-radius: 0.1rem;
}
</style>
